<div nz-row [nzGutter]="24" class="custom-row">

  <ng-template #Titletask>
    @if(showTaskHeader) {
    <div class="card-header-row">
      <div class="card-header-left">
        <span class="card-header-accent"></span>
        <span class="heading-text">Task Details</span>
      </div>
      <div class="card-header-actions">
        <button nz-button nzType="text" nzSize="small" nz-tooltip nzTooltipTitle="Edit Task" (click)="editTask(taskData)">
          <nz-icon nzType="edit" nzTheme="fill" style="color:#3f0c9e" />
        </button>
        <button
          class="custom-popconfirm"
          nz-popconfirm
          [nzPopconfirmOverlayClassName]="'custom-popconfirm-popover'"
          [nzPopconfirmTitle]="popconfirmTpl"
          nzPopconfirmPlacement="bottom"
          (nzOnConfirm)="deleteTask(taskData)"
          nz-button nzType="text" nzDanger nzSize="small"
          nz-tooltip nzTooltipTitle="Delete Task"
          *ngIf="(loggedInUser?.roles || '').toLowerCase() === 'admin'">
          <nz-icon nzType="delete" nzTheme="fill" />
        </button>
      </div>
    </div>
    } @else {
    <div class="card-header-row">
      <span class="card-header-accent"></span>
      <span class="heading-text">Basic Information</span>
    </div>
    }
  </ng-template>
  <!-- Detail Card - 40% -->
  <div nz-col [ngClass]="isConsolePage || tabData?.created_at?.length > 0 ? 'console' : 'standalone'"
    [nzSpan]="10" nzMd="10" nzSm="24" nzXs="24">
    <nz-card [nzTitle]="Titletask" [nzBordered]="true" class="shadow task-card">
      <nz-descriptions [nzColumn]="1" nzSize="small" nzBordered>
        <nz-descriptions-item nzTitle="Task ID">
          <nz-tag> {{ formatIdToFourDigits(taskData?.id) }} </nz-tag>
        </nz-descriptions-item>
        <nz-descriptions-item nzTitle="Project"> <a target="_blank" [href]="'/app/projects/' + taskData?.task_project">
            {{ taskData?.project_name }}</a></nz-descriptions-item>
        <nz-descriptions-item nzTitle="Client"><a [href]="'/app/clients/' + taskData?.project_client_id"
            target="_blank"> {{taskData?.project_client_name}} </a></nz-descriptions-item>
        <nz-descriptions-item nzTitle="Contract Value"> {{taskData?.project_cost}} </nz-descriptions-item>
        <nz-descriptions-item nzTitle="Status"><nz-tag [nzColor]="getStatusColor(taskData?.task_status)">
            {{taskData?.task_status_name}} </nz-tag></nz-descriptions-item>
        <nz-descriptions-item nzTitle="Priority">
          <nz-tag [nzColor]="getPriorityColor(taskData?.priority)" class="text-red-600 font-semibold">
            {{getTaskPriorityName(taskData?.priority)}} </nz-tag></nz-descriptions-item>
        <nz-descriptions-item nzTitle="Due Date"> {{taskData?.due_date | date:'yyyy-MM-dd' }} </nz-descriptions-item>
        <nz-descriptions-item nzTitle="Assigned to">

          <!-- <nz-avatar nzSize="small" [nzText]="user.name[0].toUpperCase()"
                     *ngFor="let user of taskData?.assigned_to_details"
                     [nzTooltipTitle]="user.name" nzTooltipPlacement="top" nz-tooltip
                     [nzSrc]="'data:image/png;base64,' + user?.photo" style="margin-right: 4px;"></nz-avatar> -->

          <ng-container *ngFor="let user of taskData?.assigned_to_details">
            <ng-container *ngIf="user?.avatarSrc || getValidAvatarSrc(user) as src; else initialsTpl">
              <img [src]="src" [alt]="user?.name" nz-tooltip [nzTooltipTitle]="user?.name"
                class="custom-avatar-image" />
            </ng-container>
            <ng-template #initialsTpl>
              <span nz-tooltip [nzTooltipTitle]="user?.name" class="custom-avatar">
                <span class="initial first">{{ (user?.initialsuser?.initialsFirst || (getUserInitials(user) | slice:0:1)) }}</span>
                <span class="initial last">{{ (user?.initialsLast || (getUserInitials(user) | slice:1:2)) }}</span>
              </span>

            </ng-template>
          </ng-container>

        </nz-descriptions-item>
        <nz-descriptions-item nzTitle="Assigned to Group">
          <nz-tag [nzColor]="'purple'" *ngFor="let user of taskData?.assigned_to_group_details" [nzBordered]="false">
            {{user?.name}} </nz-tag>

        </nz-descriptions-item>


        <nz-descriptions-item nzTitle="Additional Files">
          <span *ngFor="let file of taskData?.additional_files_details; let i = index">
            <a [href]="file?.file" download target="_blank">{{file?.name}}</a> <span
              *ngIf="i < taskData?.additional_files_details.length - 1">, </span>
          </span>
          <span *ngIf="taskData?.additional_files_details?.length == 0 || taskData?.additional_files_details == null">
            No Additional File </span>
        </nz-descriptions-item>
        <!-- <nz-descriptions-item nzTitle="Cost Approvals">
                    <nz-select [(ngModel)]="selectedAprovalModel" style="width: 100%;" >
                        <nz-option *ngFor="let item of COST_APPROVAL_STATUSES"
                         [nzValue]="item.id" [nzLabel]="item.name" [nzDisabled]="item.disabled"></nz-option>
                    </nz-select>

                    <ng-container *ngIf="selectedAprovalModel == 2">
                        <p style="margin-bottom: 0; margin-top: 10px;">Approver:</p>
                        <nz-select style="width: 100%;" >
                            <nz-option nzValue="1" nzLabel="John Doe"></nz-option>
                        </nz-select>
                        <button style="margin-top: 5px" nz-button [nzSize]="'small'" nzType="default">Save</button>
                    </ng-container>
                </nz-descriptions-item> -->

      </nz-descriptions>
    </nz-card>

  </div>

  <ng-template #TitletaskDetails>
    <div class="card-header-row">
      <div class="card-header-left" style="flex:1; min-width:0;">
        <span class="card-header-accent"></span>
        <span class="task-name-title" nz-tooltip [nzTooltipTitle]="taskData?.name">{{ taskData?.name }}</span>
      </div>
      <div class="card-header-actions">
        <label nz-checkbox [(ngModel)]="is_reviewed" (ngModelChange)="reviewTask()" class="review-checkbox">
          <span>{{ is_reviewed ? 'Reviewed' : 'Review' }}</span>
        </label>
        <button nz-button nzSize="small" nzType="default" class="history-btn" (click)="showHisory()">
          <nz-icon nzType="database" nzTheme="outline" /> History
        </button>
      </div>
    </div>
  </ng-template>

  <!-- Task Card - 60% -->
  <div nz-col [ngClass]="isConsolePage || tabData?.created_at?.length > 0 ? 'console' : 'standalone'"
    [nzSpan]="14" nzMd="14" nzSm="24" nzXs="24">

    <nz-card [nzTitle]="TitletaskDetails" [nzBordered]="true" class="shadow task-card">

      <div class="description-area" [innerHTML]="taskData?.description"
        style="box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px; border-radius: 5px;"> </div>


      <nz-divider nzText="Work Notes" class="section-divider"></nz-divider>

      <!-- Chat messages -->
      <div #commentsContainer class="comments-scroll">
        <div *ngIf="!taskCommentList?.length" class="no-comments-msg">
          No notes yet. Be the first to add one.
        </div>
        <div *ngFor="let comment of taskCommentList"
             class="chat-row"
             [class.is-me]="isCurrentUser(comment.created_by)">
          <nz-avatar *ngIf="!isCurrentUser(comment.created_by)"
            nzSize="small" nzIcon="user"
            [nzSrc]="getBase64Image(comment.created_by_image)"
            class="chat-avatar"></nz-avatar>
          <div class="chat-bubble-wrap">
            <span class="chat-author" *ngIf="!isCurrentUser(comment.created_by)">{{ comment.created_by_name }}</span>
            <div class="chat-bubble" [innerHTML]="comment.comment"></div>
            <div class="chat-meta-row">
              <span class="chat-time">{{ comment.created_at | date:'MMM d, h:mm a' }}</span>
              <button *ngIf="canEditComment(comment)" class="comment-edit-btn" nz-button nzType="link" nzSize="small" (click)="startEditComment(comment)" title="Edit">
                <span nz-icon nzType="edit"></span>
              </button>
            </div>
          </div>
          <nz-avatar *ngIf="isCurrentUser(comment.created_by)"
            nzSize="small" nzIcon="user"
            [nzSrc]="getBase64Image(comment.created_by_image)"
            class="chat-avatar"></nz-avatar>
        </div>
      </div>

      <!-- Comment Box -->
      <div class="comment-input-wrapper">
        <div *ngIf="editingComment" class="edit-mode-banner">
          <span nz-icon nzType="edit" style="margin-right:5px;"></span>
          Editing comment
          <button nz-button nzType="link" nzSize="small" class="cancel-edit-link" (click)="cancelEditComment()">Cancel</button>
        </div>
        <quill-editor theme="snow" placeholder="Write a comment… use &#64; to mention someone" class="content-editor" [modules]="quillConfig"
          [(ngModel)]="newComment"></quill-editor>
        <div class="comment-actions">
          <span class="comment-hint">
            <nz-icon nzType="info-circle" nzTheme="outline"></nz-icon>
            Type <kbd>&#64;</kbd> to mention someone
          </span>
          <button class="post-comment-btn" nz-button nzType="primary" (click)="postComment()" [disabled]="!newComment">
            <nz-icon [nzType]="editingComment ? 'save' : 'send'" nzTheme="outline"></nz-icon>
            {{ editingComment ? 'Update' : 'Post Comment' }}
          </button>
        </div>
      </div>

    </nz-card>
  </div>
</div>
<app-loader *ngIf="loading"></app-loader>
@if(showHistory){
<app-task-history [taskId]="taskData?.id" [isVisible]="showHistory" (setisVisible)="setIsVisible()"></app-task-history>
}



<ng-template #popconfirmTpl let-popconfirm="popconfirm">
    <div class="custom-popconfirm-header">
      <span class="custom-popconfirm-title">
          Confirm Deletion
      </span>
    </div>
    <div class="custom-popconfirm-icon-area">
        <span style="display: flex; justify-content: center; margin: 18px 0 8px 0;">
            <nz-icon nzType="warning-fill" nzTheme="fill" style="font-size: 32px; color: #ff6c6c;"></nz-icon>
        </span>
    </div>
    <div class="custom-popconfirm-message description">
        Are you sure you want to delete this item?<br />
        <span style="color:#888; font-size:14px;">This action cannot be undone.</span>
    </div>
</ng-template>
